(ns ui.tailwind-merge-tokens)

(def size-tokens
  "Custom size keys of the tw2 Tailwind config. Each key is a `tailwind-merge`
   class group id. Each value lists the theme keys that belong to that group.

   `tailwind-merge` does not read the Tailwind config. It cannot place a name
   such as `w-card` in the `w` group. Two classes of the same group then both
   stay in the output. The order in the stylesheet decides which class wins.

   Add a name here when `tailwind.tw2.upstream.config.js` gets a new key in
   `width`, `maxWidth`, `maxHeight` or `minHeight`. Do not add a name that
   `tailwind-merge` already knows. For example, it knows `max-w-md`."
  {"w"
   ["modal-sm"
    "modal-md"
    "modal-lg"
    "modal-xl"
    "card"
    "drawer-sm"
    "drawer-md"
    "drawer-lg"
    "dropdown-button"
    "dropdown-panel-sm"
    "dropdown-panel-md"
    "dropdown-panel-lg"
    "stepper-scroll"]

   "max-w"
   ["modal-sm"
    "modal-md"
    "modal-lg"
    "modal-xl"
    "drawer-sm"
    "drawer-md"
    "drawer-lg"
    "stepper-mobile"]

   "max-h"
   ["modal-max-height"]

   "min-h"
   ["alert"]})

(defn add-size-tokens!
  "Adds `size-tokens` to the `classGroups` object of a `tailwind-merge` config.
   Changes the object in place and returns it.

   Call this function before the step that copies each group for the `tw2`
   prefix. The prefixed classes then get the same tokens."
  [class-groups]
  (doseq [[group tokens] size-tokens]
    (.push (aget class-groups group)
           (doto (js-obj)
             (aset group (clj->js tokens)))))
  class-groups)
